import Vue from "vue";
import App from "./App.vue";
import router from "@/router/router";
import store from "@/stores";
import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/utils/veevalidateExtend";
import VueAwsomeCountdown from "vue-awesome-countdown";
import VueGtag from "vue-gtag";
import VueSimpleAlert from "vue-simple-alert";
import customModal from "@/utils/custom_modal";
import commonModal from "@/plugins/commonModal";
import { ROLE } from "@/data/role";
import lodash from "lodash";
import VueLodash from "vue-lodash";
import BlockUI from "vue-blockui";
import "@/assets/js/fontAwesomeIcon.js";
import Paginate from "vuejs-paginate";

import datePicker from "vue-bootstrap-datetimepicker";
import "@/assets/bootstrap-datetimepicker.min.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import functions from "@/plugins/functions";

//window.Kakao.init('7a9a38f6f0e2a713942f48931695322f');  // 카카오 API 앱키 (팡퍼니)
window.Kakao.init("3ddc1006fafaf39be5d523860e99608b"); // 카카오 API 앱키 (경희대학교)

Vue.config.productionTip = false;

Vue.prototype.$role = ROLE;

Vue.use(BootstrapVue);
Vue.use(VueAwsomeCountdown, "vac");
Vue.use(VueSimpleAlert);
Vue.use(customModal);
Vue.use(commonModal);
Vue.use(BlockUI);
Vue.use(datePicker);
Vue.use(VueGtag, {
  config: {
    //id: 'G-DBBDTDGC4R' // 개발서버(https://www.edupany.kr) 테스트용 측정 ID
    id: "G-79LH2JNVW5", // http://newagingplatform-b2c.co.kr/
  },
});
Vue.use(VueLodash, { lodash: lodash });

Vue.use(require("vue-pusher"), {
  api_key: "7d34939d85a9f5829e2d",
  options: {
    cluster: "ap1",
    encrypted: true,
  },
});

Vue.component("paginate", Paginate);
Vue.mixin(functions);

export const eventBus = new Vue();

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
